import Navigation from "@/components/Navigation";
import NoteInvestingHero from "@/components/education/NoteInvestingHero";
import InteractiveCalculator from "@/components/education/InteractiveCalculator";
import ProcessSteps from "@/components/education/ProcessSteps";
import SEOHead from "@/components/SEOHead";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NoteInvestingEducation = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Note Investing Education - How to Buy Land Contracts at Discount"
        description="Learn how smart investors buy land contracts and private mortgages at a discount to create superior yields. Interactive calculator and step-by-step process guide."
        keywords="note investing, land contracts, private mortgages, real estate investing, discount notes, investment yields, real estate education"
        canonicalUrl="https://contract-cash-nexus.lovable.app/note-investing-education"
      />
      
      <Navigation />
      <NoteInvestingHero />
      <ProcessSteps />
      <InteractiveCalculator />
      
      {/* Call to Action Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">
            Ready to Start Note Investing?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Access our exclusive investor portal to see real investment opportunities 
            with detailed due diligence and competitive yields.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/investor-portal">
              <Button size="lg" variant="secondary" className="bg-white text-blue-600 hover:bg-gray-100">
                Enter Investor Portal
              </Button>
            </Link>
            <Link to="/due-diligence">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-blue-600">
                Learn About Due Diligence
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-4">Contract Funding Group</h3>
          <p className="text-gray-400 mb-4">
            Educating investors about real estate's best kept secret since 1999
          </p>
          <p className="text-sm text-gray-500">
            © 2024 Contract Funding Group. All rights reserved. Licensed and insured.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default NoteInvestingEducation;